import { render } from "./SufferDiscrimination.vue?vue&type=template&id=5e6bc656"
import script from "./SufferDiscrimination.vue?vue&type=script&lang=js"
export * from "./SufferDiscrimination.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__